import { Sentry } from '@/lib/sentry'

type ReportLevel = 'fatal' | 'error' | 'warning' | 'info'

type ReportSource = 'render' | 'react-query' | 'unhandled'

interface ReportErrorContext {
  source: ReportSource
  level?: ReportLevel
  componentStack?: string | null
  /** source 외 추가 태그 (layer·owner·screen·api_code 등) */
  tags?: Record<string, string>
  /** 이슈 묶음 기준. 없으면 Sentry 기본(스택) 그룹핑 */
  fingerprint?: string[]
}

export function reportError(error: unknown, context: ReportErrorContext): void {
  const tag = `[GlobalErrorBoundary:${context.source}]`

  if (import.meta.env.DEV) {
    console.error(tag, error, {
      level: context.level ?? 'error',
      componentStack: context.componentStack,
    })
    return
  }

  // prod 콘솔 로깅 안 함 — Sentry.captureException 이 리포팅 담당.
  // (iOS WKWebView는 console 인자를 native로 postMessage 직렬화하는데 error 객체가
  //  비직렬화면 InvalidAccessError 발생 → prod 에선 애초에 console 로 안 넘김)
  // Sentry init 안 됐으면(DSN 없음) captureException은 no-op
  Sentry.captureException(error, {
    level: context.level ?? 'error',
    tags: { ...context.tags, source: context.source },
    fingerprint: context.fingerprint,
    contexts: {
      react: { componentStack: context.componentStack ?? null },
    },
  })
}
